document.querySelectorAll('.mouse-scroll, .mouse-scroll-mb').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const targetId =
      window.innerWidth < 768 ? 'mouse-scroll-mb' : 'mouse-scroll';
    const targetEl = document.getElementById(targetId);

    if (targetEl) {
      targetEl.scrollIntoView({ behavior: 'smooth' });
    }
  });
});
